'use client';

import { type TimeOfDay } from '../_lib/class-filters';
import { BookingChoiceButton } from './booking-choice-button';

/**
 * "Morning | Afternoon | Evening" above a time-slot grid, in the same choice
 * style as the slots. Starts unselected (every time shows); tapping a part
 * narrows to it and tapping it again clears. `options` are the parts of the
 * day the current slots actually cover.
 */
export function TimeOfDayFilter({
  options,
  value,
  onChange,
  t,
}: {
  options: TimeOfDay[];
  value: TimeOfDay | null;
  onChange: (value: TimeOfDay | null) => void;
  t: (key: string) => string;
}) {
  return (
    <div
      role="group"
      aria-label={t('timeFilter.label')}
      className="mb-3 grid auto-cols-fr grid-flow-col gap-2"
      data-test="time-of-day-filter"
    >
      {options.map((option) => (
        <BookingChoiceButton
          key={option}
          selected={value === option}
          className="w-full px-1"
          onClick={() => onChange(value === option ? null : option)}
        >
          {t(`classFilters.timesShort.${option}`)}
        </BookingChoiceButton>
      ))}
    </div>
  );
}
